import { request } from '@/utils/request'
export default {
    masterPic: (params, loading) => {
        return request('/api/purchaseproductinfo/purchase', params, loading)
    },
    buyList: (params, loading) => {
        return request('/api/purchaseproductinfo/list', params, loading)
    },
    buyAdd: (params, loading) => {
        return request('/api/purchaseproductinfo/add', params, loading)
    },
    buyEdit: (params, loading) => {
        return request('/api/purchaseproductinfo/edit', params, loading)
    },
    buyDel: (params, loading) => {
        return request('/api/purchaseproductinfo/delete', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/buyService.js